import { SSN_PATTERN_SOURCE } from '@repo/common/redaction';

// Also matches a hand-masked SSN (xxxx-xx-1234).
const SSN_PATTERN = /(\b[\dx*]{3}|\*{3})-[\dx*]{2}-(\d{4}\b|\d{0,3}\s*▊)/gi;
const SSN_REPLAY_MASK = '■■■-■■-■■■■';

// Single source of truth for which containers hold PII text, so PostHog's maskTextSelector stays
// in sync with every place that renders it.
export const PII_TEXT_SELECTOR =
  '.content-text, .note-message-body, .message-content, .tool-call-result, .chat-history-preview';

// Backup only: MaskedSsnText already blocks SSNs from PostHog at render time — this regex just catches PII that slips through some other path.
// Must never throw: PostHog silently drops replay data for every mutation this touches if it does.
export function maskSessionReplayText(text: string): string {
  if (typeof text !== 'string') return text;
  return text.replace(SSN_PATTERN, SSN_REPLAY_MASK);
}

export interface TextSegment {
  text: string;
  isSsn: boolean;
}

// Splits `text` into plain and SSN segments, so a renderer can wrap just the SSN parts in
// PostHog's block class instead of masking the whole string.
export function splitOnSsn(text: string): TextSegment[] {
  const segments: TextSegment[] = [];
  let cursor = 0;
  for (const match of text.matchAll(SSN_PATTERN)) {
    if (typeof match.index !== 'number') continue;
    if (match.index > cursor) {
      segments.push({ text: text.slice(cursor, match.index), isSsn: false });
    }
    segments.push({ text: match[0], isSsn: true });
    cursor = match.index + match[0].length;
  }
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), isSsn: false });
  }
  return segments;
}
